import { InputChangeEvent } from "@progress/kendo-react-inputs/dist/npm/input/interfaces/InputChangeEvent";
import { DatePicker, DatePickerChangeEvent } from "@progress/kendo-react-dateinputs";
import * as React from "react";
import { useContext } from "react";
import { TextArea, TextAreaChangeEvent } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { EditProjectContext } from "./EditProjectContext";
import { getProjectStateDisplayName } from "../ViewModel/ProjectState";
import Row from "../../Layout/PageGrid/Row";
import Col from "../../Layout/PageGrid/Col";
import TextInput from "../../Layout/Inputs/TextInput";
import { isProjectReadOnly } from "./IsProjectReadOnly";
import { InterimNetworkSwitch } from "./EditProjectPageMenu/InterimNetworkSwitch";
import { ShowInOverviewSwitch } from "./EditProjectPageMenu/ShowInOverviewSwitch";
import AuditLog from "./AuditLog";
import { kendoDefaultDateFormatddMMyyyy } from "../../Utils/dates";
import { ReadOnlyProps } from "./ReadOnlyProps";

type Props = {
  handleChanges: (event: InputChangeEvent | DatePickerChangeEvent) => void;
  handleTextAreaChanges: (event: TextAreaChangeEvent) => void;
};

export const TopBaseData = ({
  handleChanges,
  handleTextAreaChanges,
  isReadOnly,
}: Props & ReadOnlyProps) => {
  const { project } = useContext(EditProjectContext);
  const isProjectOrUserReadOnly = isProjectReadOnly(project) || isReadOnly;

  return (
    <div style={{ marginBottom: "2rem", padding: "0.3rem", fontSize: "1rem" }}>
      <Row gap="25px" marginBottom="1rem">
        <Col width="20%">
          <TextInput label="Project Number" disabled value={project.ProjectId} />
        </Col>

        <Col width="20%">
          <TextInput
            label="Project Reference"
            name="ProjectReference"
            value={project.ProjectReference || ""}
            onChange={handleChanges}
            disabled={isProjectOrUserReadOnly}
          />
        </Col>

        <Col width="20%">
          <TextInput
            label="Project Name"
            name="Name"
            value={project.Name || ""}
            onChange={handleChanges}
            disabled={isProjectOrUserReadOnly}
          />
        </Col>

        <Col width="20%">
          <DatePicker
            label="Start Date"
            name="StartDate"
            value={project.StartDate}
            format={kendoDefaultDateFormatddMMyyyy}
            weekNumber
            onChange={handleChanges}
            disabled={isProjectOrUserReadOnly}
          />
        </Col>

        <Col width="20%">
          <DatePicker
            label="End Date"
            name="EndDate"
            value={project.EndDate}
            format={kendoDefaultDateFormatddMMyyyy}
            weekNumber
            onChange={handleChanges}
            disabled={isProjectOrUserReadOnly || !project.IsInterimNetworkProject}
          />
        </Col>

        <Col width="20%">
          <TextInput
            label="State"
            name="State"
            value={getProjectStateDisplayName(project.State)}
            disabled
          />
        </Col>
      </Row>

      <Row gap="25px" marginBottom="0.5rem">
        <Col width="33.85%">
          <Label style={{ fontSize: 14 }}>Comment</Label>
          <TextArea
            name="Comment"
            value={project.Comment || ""}
            onChange={handleTextAreaChanges}
            disabled={isProjectOrUserReadOnly}
            rows={1}
            autoSize
          />
        </Col>

        <InterimNetworkSwitch disabled={isProjectOrUserReadOnly} />
        <ShowInOverviewSwitch disabled={isProjectOrUserReadOnly} />
        <AuditLog />
      </Row>
    </div>
  );
};
